import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteKiloClass, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type NoShowAthleteClassVars = {
  athleteKiloClassId: string;
  chargeNow: boolean;
  chargeDate: string | null;
  chargeFee: number;
  deductCredit: boolean;
  paymentMethod?: string | null;
  taxRate?: number | null;
  nonStripePaymentMethod?: string | null;
  autoPay?: boolean;
  addToNextInvoice?: boolean;
};

export default function useNoShowAthleteClass(): UseMutationResult<
  AxiosResponse<AthleteKiloClass>,
  AxiosError<ErrorMessage>,
  NoShowAthleteClassVars
> {
  const queryClient = useQueryClient();

  const noShowAthleteClass = ({
    athleteKiloClassId,
    ...payload
  }: NoShowAthleteClassVars): Promise<AxiosResponse<AthleteKiloClass>> => {
    return client.post(`athlete-kilo-classes/${athleteKiloClassId}/no-show/`, payload);
  };

  return useMutation(noShowAthleteClass, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athleteClasses'] });
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['classes'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
